export enum EnqActionTypes {
  API_RESPONSE_SUCCESS = "@@enq/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@enq/API_RESPONSE_ERROR",

  GET_ENQ = "@@enq/GET_ENQ",
  DELETE_ENQ = "@@enq/DELETE_ENQ",
}
